import { tokenIconSource, reminderIconSource } from "./roleIcon";

// 冻结的是数据和原圆桌的展示坐标，不保存HTML、Canvas或截图。
// 坐标直接取现有Player/Token实例，不另算圆周、不重排提示标记。
export function captureGrimoireFrame(store) {
  const state = store.state,
    circle = document.querySelector("#townsquare > .circle");
  const seats = circle && [...circle.children];
  if (
    !circle ||
    seats.length !== state.players.players.length ||
    !circle.clientWidth ||
    !circle.clientHeight
  )
    return null;
  const root = circle.getBoundingClientRect();
  const box = (node, origin = root) => {
    const r = node.getBoundingClientRect();
    return {
      x: r.left - origin.left,
      y: r.top - origin.top,
      width: r.width,
      height: r.height,
    };
  };
  const shownImage = (node) => {
    if (!node) return "";
    const match = getComputedStyle(node).backgroundImage.match(
      /^url\(["']?(.*?)["']?\)$/,
    );
    if (!match) return "";
    const url = new URL(match[1], window.location.href);
    return url.origin === window.location.origin
      ? url.pathname + url.search + url.hash
      : url.href;
  };
  const role = (r, token) => ({
    ...(r || {}),
    snapshotImage:
      (r?.id &&
      token?.classList.contains(r.id) &&
      !token.classList.contains("profile-avatar")
        ? shownImage(token.querySelector(".icon"))
        : "") || tokenIconSource(r || {}, state.grimoire),
  });
  const geometry = [];
  const players = state.players.players.map((p, index) => {
    const seat = seats[index],
      player = seat.querySelector(".player"),
      name = player.querySelector(":scope > .name");
    const token = player.querySelector(":scope > .token");
    const reminders = [
      ...seat.querySelectorAll(":scope > .reminder:not(.add)"),
    ];
    geometry.push({
      player: box(player),
      name: name
        ? {
            ...box(name, player.getBoundingClientRect()),
            fontSize: parseFloat(getComputedStyle(name).fontSize),
            lineHeight: parseFloat(getComputedStyle(name).lineHeight),
          }
        : null,
      reminders: reminders.map((node) => box(node)),
    });
    const component = seat.__vue__;
    return {
      ...p,
      avatar: component?.primaryProfileAvatar || p.avatar || "",
      syncState: component?.identitySyncState || "",
      displayName: component?.seatDisplayName || p.name || "空",
      role: role(p.role, token),
      alignment:
        p.alignment ||
        (["minion", "demon"].includes(p.role?.team) ? "evil" : "good"),
      firstOrder: state.grimoire.isNightOrder
        ? store.getters["players/nightOrder"].get(p)?.first || 0
        : 0,
      otherOrder: state.grimoire.isNightOrder
        ? store.getters["players/nightOrder"].get(p)?.other || 0
        : 0,
      reminders: (p.reminders || []).map((r, i) => ({
        ...r,
        snapshotImage:
          shownImage(reminders[i]?.querySelector(".icon")) ||
          reminderIconSource(r, state.grimoire),
      })),
    };
  });
  const bluffTokens = [
    ...document.querySelectorAll("#townsquare > .bluffs .token"),
  ];
  return {
    players,
    bluffs: state.players.bluffs.map((r, i) => role(r, bluffTokens[i])),
    markedPlayer: state.session.markedPlayer,
    isNight: state.grimoire.isNight,
    layout: {
      width: root.width,
      height: root.height,
      fontSize: parseFloat(getComputedStyle(circle).fontSize),
      seats: geometry,
    },
  };
}
